<template>
	<base-user-list
		v-loading="loading"
		:users="users"
		show-filter
		detail-link="employee-edit"
		new-link="employee-new"
		@get-page="loadData" />
</template>

<script>
import { BaseUserList } from '@/components/Base';

export default {
	name: 'EmployeesList',
	components: {
		BaseUserList,
	},
	data() {
		return {
			users: {},
			loading: false,
		};
	},
	methods: {
		async loadData(params) {
			this.loading = true;
			this.users = await this.$service.admin.getEmployeeList(params);
			this.loading = false;
		},
	},
};
</script>
